<template>
  <div id="app" class="app" @click="isTimeOut">
    <headerTop v-show="!$route.meta.hideHeader"></headerTop>
    <div>
      <router-view v-if="isRouterAlive"></router-view>
    </div>

    <footerBtm v-show="!$route.meta.hideFooder"></footerBtm>

    <el-popover class="fixed" placement="left-start" title="" width="250" trigger="hover">

      <div v-html="richText"></div>

      <div slot="reference">
        <div class="online" id="kuainiaoip">
          <img src="@/assets/img/cs.png" alt="">
          <span>在线咨询</span>
        </div>
      </div>
    </el-popover>

    <!-- <el-backtop class="square-backtop" :right="50" :bottom="302"></el-backtop> -->


    <el-backtop :right="60" :bottom="302"></el-backtop>
  </div>
</template>

<script>
import headerTop from '@/components/headerTop.vue'
import footerBtm from '@/components/footerBtm.vue'

export default {
  name: 'app',
  components: {
    headerTop,
    footerBtm
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      richText: `<div class="link bot"></div>`,
      msg: '',
      gotop: false,
      isRouterAlive: true,
      lastTime: null,
      currentTime: null,
      timeOut: 1 * 30 * 60 * 1000
    }
  },
  created() {
    this.lastTime = new Date().getTime()

  },
  mounted() {


    const data = {
      id: 2
    }
    this.$apiFun.article(data).then(res => {
      console.log(res)
      if (res.code) {
        this.richText = res.data.content
      }
    }).catch(err => {
      console.log(err)
    })



  },
  methods: {
    // 拉取QQ
    toQD() {
      window.open('https://wpa1.qq.com/WQx091qv?_type=wpa&qidian=true', '_blank')
    },
    // 超时自动关闭
    isTimeOut() {
      // 记录这次的点击时间
      this.currentTime = new Date().getTime()
      // console.log(this.currentTime - this.lastTime)
      // console.log(this.timeOut)
      // 判断上次最后一次点击时间和这次点击时间间隔是否大于30分钟
      if (this.currentTime - this.lastTime > this.timeOut) {
        // 若为登录状态
        if (sessionStorage.getItem('token')) {
          // this.$message.error('登录超时，请重新登录')
          sessionStorage.removeItem('token')
          setTimeout(() => {
            this.$router.push('/')
            // 先返回首页,在给提示,可以根据具体需求调整
            this.$alert('检测到您长时间未操作页面,请重新登录!', '温馨提示', {
              confirmButtonText: '确定',
              callback: (action) => {
                location.reload()
              }
            })
          }, 2000)
        } else {
          this.lastTime = new Date().getTime()
        }
      } else {
        // 若30分钟内点击，则覆盖之前存储的最后一次点击时间
        this.lastTime = new Date().getTime()
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    handleScroll() {
      const scrolltop = document.documentElement.scrollTop || document.body.scrollTop
      // console.log('scrolltop', scrolltop)
      if (scrolltop > 100) {
        this.gotop = true
      } else {
        this.gotop = false
      }
    },
    totop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // console.log('top', top)
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },

    getUserInfo() {
      this.$apiFun.getUserInfo().then(res => {
        // console.log(res)
        if (res.code == 1) {
          this.veri = res.data.certificationType
          sessionStorage.setItem('indet', res.data.certificationType)
        }
      })
    }
  },
  watch: {
    // 页面跳转后返回顶部
    $route(to) {
      document.getElementsByClassName('app')[0].scrollTop = 0 // 设置滚动条位置
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}

.totop {
  position: fixed;
  bottom: 290px;
  right: 50px;
  z-index: 3;
  /* box-shadow: 2px 2px 10px #efefef; */
  box-shadow: 0 2px 6px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}

.fixed {
  position: fixed;
  /* bottom: 445px; */
  bottom: 360px;
  right: 50px;
  z-index: 3;
}

.online {
  color: #409eff;
  /* border-radius: 10px; */
  background-color: #fff;
  /* width: 40px; */
  /* height: 130px; */
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #efefef;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  /* box-shadow: 2px 2px 10px #efefef; */
  cursor: pointer;
}

.online span {
  font-size: 12px;
}

.online:hover {
  background-color: #efefef;
}

/* .online span:after{
  content: '点击咨询';
  cursor: pointer;
  position: absolute;
  opacity: 0;
  top: -20px;
  right: 0;
  transition: 1s;
  padding: 9px 20px;
  display: flex;
  flex-direction: column;
  background-color: #409eff;
  border: 2px solid #409eff;
  color: #fff;
  border-radius: 10px;
} */
/* .online:hover span {
  padding-right: 3.55em;
} */
.online:hover span:after {
  opacity: 4;
  top: 0;
}

.bot {
  border-bottom: 1px solid #efefef;
  align-items: center;
}

.link {
  display: flex;
  justify-content: flex-start;
  padding: 10px;
}

::v-deep .el-button {
  border: none;
}

.bg-purple-dark {
  margin-top: 100px;
}

/* 去除按钮点击/聚焦后的外围黑框 */
.el-button:focus,
.el-button:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

/* 方形回顶按钮 */
.square-backtop.el-backtop {
  border-radius: 2px;
  /* 0 = 纯直角方形；4-8px = 微圆角方形，视觉更柔和 */
  width: 64px;
  /* 按钮宽度，可按需调整 */
  height: 6%;
  /* 按钮高度，和宽度一致保持正方形 */
  line-height: 64px;
  /* 保持箭头图标垂直居中 */
  font-size: 24px;
  /* 箭头图标大小 */
}

.square-backtop .el-backtop__content {
  border-radius: 2px;
  /* 内部内容同步圆角，避免样式透出 */
}
.el-container,
.el-main {
  background-color: transparent;
}
</style>
